import getMLRTableFormatTab from './mlr-table-format-tab/getMLRTableFormatTab';
import { computedFn } from 'mobx-utils/lib/computedFn';
import type { RibbonTabDefinitionBase } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components';
import type { RibbonControlDefinitionProps } from 'owa-mail-ribbon-utils';
import { getMailRibbonConfigStore } from 'owa-mail-ribbon-store';
import ContextualRibbonTab from 'owa-mail-ribbon-store-shared-types/lib/types/contextualRibbonTab';

const getContextualMlrTabsDefinition = computedFn(
    (props: RibbonControlDefinitionProps): RibbonTabDefinitionBase[] => {
        const tabs: RibbonTabDefinitionBase[] = [];
        const contextualTabs: ContextualRibbonTab[] = getMailRibbonConfigStore.contextualTabs;

        contextualTabs.forEach(tab => {
            switch (tab) {
                case ContextualRibbonTab.Tab_Table_Format:
                    tabs.push(getMLRTableFormatTab(props));
                    break;
                default:
                    throw new Error(
                        'Unknown control: ' +
                            tab +
                            ' searched for in getContextualMlrTabsDefinition'
                    );
            }
        });

        return tabs;
    }
);

export default getContextualMlrTabsDefinition;
